import AIOButtonComponent from "@components/Button.component";
import AIOSearchComponent from "@components/input/AIOSearch.component";
import JobBoardWithoutStripeModal from "@components/modal/JobBoardWithoutStripe.modal";
import ModalComponent from "@components/modal/Modal.component";
import { Box, Grid, Stack, Typography, useMediaQuery, useTheme } from "@mui/material";
import { useObservable } from "@ngneat/react-rxjs";
import { jobBoardsQuery } from "@store/jobBoards";
import { stripeProductsService } from "@store/stripe/products/stripeProducts.service";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import JobBoardWithoutStripeCard from "@components/cards/JobBoardWithoutStripe.card";

const AdminJobboardWithoutStripe = () => {
  const { t } = useTranslation();

  const theme = useTheme();
  const breakpointDownSM = useMediaQuery(theme.breakpoints.down("sm"));
  const [jobBoardWithoutStripe] = useObservable(jobBoardsQuery.jobBoardsWithoutStripe$);

  const [openModalAddJobBoardWithoutStripe, setOpenModalAddJobBoardWithoutStripe] = useState(false);

  return (
    <Stack px={breakpointDownSM ? "10px" : "40px"} flex={1} width="100%" overflow="auto">
      <Stack direction="row" alignItems="center" spacing={2} mb={breakpointDownSM ? "0px" : "28px"}>
        <Typography fontSize="20px" fontWeight="700">
          {t(`adminParameters.jobboardWithoutStripe.amount`, { count: jobBoardWithoutStripe.length })}
        </Typography>
      </Stack>
      <Stack py={breakpointDownSM ? "20px" : undefined} spacing={"20px"}>
        <Stack direction="row" alignItems="center" justifyContent="flex-end" width="100%">
          <Stack
            direction={breakpointDownSM ? "column-reverse" : "row"}
            width="100%"
            alignItems="center"
            spacing={breakpointDownSM ? 0 : 3}
            justifyContent={breakpointDownSM ? "flex-start" : "flex-end"}
            mb={breakpointDownSM ? "20px" : 0}>
            <AIOSearchComponent
              width="100%"
              placeholder={t("adminParameters.jobboardWithoutStripe.search")}
              onChange={(value) => stripeProductsService.setFilters({ search: value })}
            />
            <Box width="fit-content" whiteSpace="nowrap">
              <AIOButtonComponent
                onClick={() => setOpenModalAddJobBoardWithoutStripe(true)}
                icon={<img alt="" src="/images/add-2.svg" />}
                title={t("adminParameters.jobboardWithoutStripe.addJobboard")}
                variant="contained"
                color="secondary"
              />
            </Box>
          </Stack>
        </Stack>
        <Grid container spacing={2}>
          {jobBoardWithoutStripe.map((jobBoard) => (
            <Grid item xs={12} sm={6} md={4} lg={3} key={jobBoard.id}>
              <JobBoardWithoutStripeCard jobBoard={jobBoard} />
            </Grid>
          ))}
        </Grid>
      </Stack>
      {openModalAddJobBoardWithoutStripe && (
        <ModalComponent
          handleClose={() => setOpenModalAddJobBoardWithoutStripe(false)}
          title={t("adminParameters.jobboardWithoutStripe.addJobboard")}
          maxWidth="sm"
          content={<JobBoardWithoutStripeModal onClose={() => setOpenModalAddJobBoardWithoutStripe(false)} />}
        />
      )}
    </Stack>
  );
};

export default AdminJobboardWithoutStripe;
